module.exports = __webpack_public_path__ + "media/video.6845a3f9.mp4";